import request from '@/utils/request'

// 获取储值卡商城列表
export async function api_getValueCardStoreList(params) {
  return request({
    url: '/rest/stored/card/admin/mall/page',
    method: 'get',
    params,
  })
}

// 获取所有上架中的储值卡
export async function api_getEfficientValueCardList(params) {
  return request({
    url: '/rest/storedcard/template/getAllCard',
    method: 'get',
    params,
  })
}

// 创建储值卡商品
export async function api_postValueCardStoreAdd(data) {
  return request({
    url: '/rest/stored/card/admin/mall/create',
    method: 'post',
    data,
  })
}

// 更新储值卡商品
export async function api_postValueCardStoreUpdate(data) {
  return request({
    url: '/rest/stored/card/admin/mall/update',
    method: 'post',
    data,
  })
}

// 上下架储值卡商品
export async function api_putValueCardProductStatusChange(params) {
  return request({
    url: '/rest/stored/card/admin/mall/effective',
    method: 'put',
    params,
  })
}

// 获取储值卡商品详细信息
export async function api_getValueCardStoreDetail(params) {
  return request({
    url: '/rest/stored/card/admin/mall/detail',
    method: 'get',
    params,
  })
}


//储值卡分销数据导出
export async function api_getValueCardDistributionDataExport(params) {
  return request({
    url: '/rest/stored/card/admin/mall/share/data/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}